import { MessageCircle } from "lucide-react";
import { waLink, DEFAULT_WA_MESSAGE } from "@/config";

export const FloatingWhatsApp = () => (
  <a
    href={waLink(DEFAULT_WA_MESSAGE)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-btn"
    className="fixed bottom-6 right-6 z-50 group flex items-center gap-3"
    aria-label="Falar no WhatsApp"
  >
    <span className="hidden sm:block opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 bg-navy text-ivory text-xs font-semibold px-4 py-2 rounded-full shadow-xl border border-gold/30">
      Online agora — fale conosco
    </span>
    <span className="relative">
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-wa-ring" />
      <span className="relative w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_12px_30px_rgba(37,211,102,0.45)] transition-transform duration-300 group-hover:scale-110">
        <MessageCircle className="w-7 h-7 text-white fill-white" />
      </span>
    </span>
  </a>
);
